import { useState } from "react";
import { Link, useNavigate, useSearchParams } from "react-router-dom";
import { toast } from "sonner";
import { api, formatApiError } from "@/lib/api";

export default function AdminResetPassword() {
    const [params] = useSearchParams();
    const nav = useNavigate();
    const emailFromUrl = params.get("email") || "";
    const tokenFromUrl = params.get("token") || "";
    const [pwd, setPwd] = useState("");
    const [pwd2, setPwd2] = useState("");
    const [loading, setLoading] = useState(false);

    const linkValid = emailFromUrl && tokenFromUrl && tokenFromUrl.length >= 32;

    const submit = async (e) => {
        e.preventDefault();
        if (pwd.length < 8) { toast.error("Le mot de passe doit faire au moins 8 caractères."); return; }
        if (pwd !== pwd2) { toast.error("Les deux mots de passe ne correspondent pas."); return; }
        setLoading(true);
        try {
            await api.post("/auth/reset_password", {
                email: emailFromUrl,
                token: tokenFromUrl,
                new_password: pwd,
            });
            toast.success("Mot de passe mis à jour. Vous pouvez vous connecter.");
            setTimeout(() => nav("/admin/login"), 800);
        } catch (err) {
            toast.error(formatApiError(err));
        } finally {
            setLoading(false);
        }
    };

    return (
        <div className="min-h-screen bg-brand-beige flex items-center justify-center p-6">
            <div className="bg-white rounded-3xl p-8 max-w-md w-full shadow-sm" data-testid="admin-reset-password-page">
                <h1 className="font-heading text-3xl text-brand-ink font-semibold mb-2">Nouveau mot de passe</h1>
                <p className="text-sm text-brand-ink/60 mb-6">
                    Choisissez un nouveau mot de passe (8 caractères minimum) pour votre espace conseiller.
                </p>

                {!linkValid && (
                    <div className="rounded-xl bg-red-50 border border-red-200 p-3 text-sm text-red-700 mb-4" data-testid="reset-invalid-link">
                        Lien invalide ou incomplet. Retournez à la page de connexion et demandez un nouveau lien.
                    </div>
                )}

                <form onSubmit={submit} className="space-y-3">
                    <label className="block">
                        <span className="block text-sm text-brand-ink/70 mb-1">Adresse e-mail</span>
                        <input type="email" value={emailFromUrl} readOnly
                            className="w-full min-h-[48px] rounded-xl border border-brand-ink/10 bg-brand-beige/40 px-4 text-brand-ink/70"
                            data-testid="reset-email-readonly" />
                    </label>
                    <label className="block">
                        <span className="block text-sm text-brand-ink/70 mb-1">Nouveau mot de passe</span>
                        <input type="password" required minLength={8} value={pwd}
                            onChange={(e) => setPwd(e.target.value)}
                            className="w-full min-h-[48px] rounded-xl border border-brand-ink/15 px-4 focus:outline-none focus:ring-2 focus:ring-[#2A84C8]/30 focus:border-[#2A84C8]"
                            data-testid="reset-input-password" />
                    </label>
                    <label className="block">
                        <span className="block text-sm text-brand-ink/70 mb-1">Confirmer le mot de passe</span>
                        <input type="password" required minLength={8} value={pwd2}
                            onChange={(e) => setPwd2(e.target.value)}
                            className="w-full min-h-[48px] rounded-xl border border-brand-ink/15 px-4 focus:outline-none focus:ring-2 focus:ring-[#2A84C8]/30 focus:border-[#2A84C8]"
                            data-testid="reset-input-password-confirm" />
                    </label>
                    <button disabled={loading || !linkValid} className="primary-btn w-full mt-2" data-testid="reset-submit-btn">
                        {loading ? "Mise à jour..." : "Enregistrer le nouveau mot de passe"}
                    </button>
                </form>

                <Link to="/admin/login" className="block text-center text-sm text-brand-ink/50 hover:text-[#2A84C8] mt-4">
                    Retour à la connexion
                </Link>
            </div>
        </div>
    );
}
